import React, { useEffect, useState } from "react";
import DataTable from "../../Components/Table";
import { useHistory, useRouteMatch } from "react-router";
import axios from "axios";
import moment from "moment";

const NotificationsTable = (props) => {
  const { openModal, setOpenModal, setCurrentRowData, tableUpdate } = props;

  // const [data, setData] = useState([]);
  const history = useHistory();
  const { path } = useRouteMatch();

  // const getNotificationData = async () => {
  //   try {
  //     data["communicationId"] = new Date().valueOf();

  //     let response = await axios.get(
  //       process.env.REACT_APP_BASE_URL + "/api/v1/communication",
  //       data
  //     );
  //     // console.log(response);
  //     setData(response.data.data);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // useEffect(() => {
  //   getNotificationData();
  // }, [tableUpdate]);

  const columns = [
    {
      title: "Date",
      field: "date",
      type: "date",
      render: (rowData) => (
        <div
          style={{ borderRadius: "50%" }}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <div
            style={{
              fontFamily: "Mulish",
              fontStyle: "normal",
              fontWeight: "normal",
            }}
          >
            {moment(rowData.date).format("DD/MM/YYYY")}
          </div>
        </div>
      ),
    },
    {
      title: "Time",
      field: "date",
      type: "date",
      render: (rowData) => (
        <div
          style={{ borderRadius: "50%" }}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          {/* <div
            style={{
              color: "rgb(39 39 39 / 85%)",
              fontFamily: "Mulish",
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "20px",
              lineHeight: "25px",
            }}
          >
            {moment(rowData.dateAndTime).format("DD MMM YYYY")}
          </div> */}
          <div
            style={{
              // color: "#757575",
              fontFamily: "Mulish",
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "18px",
            }}
          >
            {moment(rowData.date).format("HH:mm:ss")}
          </div>
        </div>
      ),
    },
    {
      title: "Company Email",
      field: "companyEmail",
    },
    {
      title: "Member Name",
      field: "memberName",
    },
    {
      title: "Member Email",
      field: "memberEmail",
    },
    {
      title: "Subject",
      field: "subject",
    },
  ];

  const data = [
    {
      date: new Date(),
      companyEmail: "company@gmail.com",
      memberName: "Sandeep Sokle",
      memberEmail: "member@gmail.com",
      subject: "Subject",
    },
    {
      date: new Date(),
      companyEmail: "company@gmail.com",
      memberName: "Sandeep Sokle",
      memberEmail: "member@gmail.com",
      subject: "Subject",
    },
    {
      date: new Date(),
      companyEmail: "company@gmail.com",
      memberName: "Sandeep Sokle",
      memberEmail: "member@gmail.com",
      subject: "Subject",
    },
    {
      date: new Date(),
      companyEmail: "company@gmail.com",
      memberName: "Sandeep Sokle",
      memberEmail: "member@gmail.com",
      subject: "Subject",
    },
    {
      date: new Date(),
      companyEmail: "company@gmail.com",
      memberName: "Sandeep Sokle",
      memberEmail: "member@gmail.com",
      subject: "Subject",
    },
    {
      date: new Date(),
      companyEmail: "company@gmail.com",
      memberName: "Sandeep Sokle",
      memberEmail: "member@gmail.com",
      subject: "Subject",
    },
    {
      date: new Date(),
      companyEmail: "company@gmail.com",
      memberName: "Sandeep Sokle",
      memberEmail: "member@gmail.com",
      subject: "Subject",
    },
    {
      date: new Date(),
      companyEmail: "company@gmail.com",
      memberName: "Sandeep Sokle",
      memberEmail: "member@gmail.com",
      subject: "Subject",
    },
    {
      date: new Date(),
      companyEmail: "company@gmail.com",
      memberName: "Sandeep Sokle",
      memberEmail: "member@gmail.com",
      subject: "Subject",
    },
  ];

  const options = {
    search: true,
    selection: false,
    filtering: true,

    headerStyle: {
      backgroundColor: "#E7E7E7",
      color: "#000",
      fontWeight: "bold",
    },
    maxBodyHeight: "45vh",
    pageSize: 10,
  };

  return (
    <>
      <DataTable
        title=""
        columns={columns}
        data={data}
        options={options}
        onRowClick={(event, rowData) => {
          // history.push(`${path}/member-info`);
          setOpenModal(true);
          setCurrentRowData(rowData);
        }}
      />
    </>
  );
};

export default NotificationsTable;
